import React from "react";

export const Loading = ({ children, style = {} }) => {

  const loadingStyle = {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
    fontWeight: "600",
  }

  // Merge with custom style
  Object.assign(loadingStyle, style);

  return (
    <div
      style={loadingStyle}
    >
      {children || "Loading..."}
    </div>
  );
};

export default Loading;
